import axios from '@/plugins/axiosInstance'
import { suggestions } from '@/networking/urlManager'

/**
 * Öneri oluşturma API çağrısını yapar
 * @param {Object} suggestionData - Oluşturulacak öneri verileri
 * @returns {Promise<Object>} API yanıtı
 */
export const createSuggestion = async (suggestionData) => {
  try {
    const response = await axios.post(suggestions.create, suggestionData, {
      timeout: 10000, // 10 saniye timeout
    })

    return response.data
  } catch (error) {
    // Hata fırlatmayı service katmanında yakalaması için bırak
    throw error
  }
}
